import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import FacebookService from './FacebookService';
import { AuthenticationActionCreator } from '../../actions/AuthenticationActionCreator';
import Alert from '../../core/Alert';
import { isError } from '../../models/core/error/IError';

const useLoginHandler = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  return useCallback(async (response: fb.StatusResponse) => {
    try {
      const accessToken = response.authResponse.accessToken;

      FacebookService.getUserData('me', async (_err, userData) => {
        if (!userData?.email) {
          Alert.alert('Fehler beim Abrufen der Facebook-Daten', 'Email fehlt.');
          return;
        }

        const result = await dispatch(
          AuthenticationActionCreator.loginFacebookUser({
            fbAccessToken: accessToken,
            data: userData
          })
        );

        if (isError(result)) {
          Alert.alert('Login fehlgeschlagen', 'Bitte versuche es erneut.');
          return;
        }

        const redirect = new URLSearchParams(location.search).get('redirect') || '/explorer';
        history.replace(redirect);
      });
    } catch (err) {
      Alert.alert('Facebook Login Fehler', 'Etwas ist schiefgelaufen.');
    }
  }, [dispatch, history, location]);
};

export default useLoginHandler;
